'use strict';

(function () {
	'use strict';

	fiscalService.$inject = ['$http', '$q', 'baseService', 'appConfig'];
	angular.module('app.services').factory('fiscalService', fiscalService);

	/* @ngInject */
	function fiscalService($http, $q, baseService, appConfig) {

		var service = {
			Revenue: { name: 'revenue', apiPath: 'revenue', codesApiPath: 'revenue_codes', columns: 'code,depth,title,modulated,established,collected' },
			Expenses: { name: 'expenses', apiPath: 'expenses', codesApiPath: 'expenses_codes', columns: 'code,depth,title,modulated,ordered,paid' },

			getCodes: getCodes,
			getCodesByType: getCodesByType,
			treeifyCodesList: treeifyCodesList,
			flattenCodesTree: flattenCodesTree,

			getDataTypes: getDataTypes,

			getYearRange: getYearRange,
			getFormDefaults: getFormDefaults,
			getLatestYearTotals: getLatestYearTotals,

			// getDataByFiscalYear  : getDataByFiscalYear,
			// getDataByFiscalYearId: getDataByFiscalYearId,

			// getEntriesPerFiscalYear: getEntriesPerFiscalYear,
			getCodeEntriesPerFiscalYear: getCodeEntriesPerFiscalYear
		};

		return service;

		////////////////

		/**
   * 
   * @param {*} maxDepth 
   * @param {*} asTree 
   */
		function getCodes() {
			var maxDepth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
			var asTree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			return $q.all({
				revenue: getCodesByType(service.Revenue, maxDepth, asTree),
				expenses: getCodesByType(service.Expenses, maxDepth, asTree)
			});
		}

		/**
   * 
   * @param {*} type 
   * @param {*} maxDepth 
   * @param {*} asTree 
   */
		function getCodesByType(type) {
			var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
			var asTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			var params = {
				select: 'code,title,depth',
				depth: 'lte.' + maxDepth,
				order: 'code.asc'
			};

			return $http.get(appConfig.apiUrl + '/' + type.codesApiPath, { params: params }).then(function (response) {

				var codesList = _(response.data).filter(function (o) {
					return _.includes(o.code, '.');
				});

				if (asTree) {
					return treeifyCodesList(codesList);
				}

				return codesList.value();
			});
		}

		/**
   * 
   */
		function getDataTypes() {
			return $q.when({
				revenue: service.Revenue,
				expenses: service.Expenses
			});
		}

		/**
   * 
   */
		function getFormDefaults() {
			return $q.when({
				from: moment().subtract(5, 'years').startOf('year'),
				to: moment().endOf('year')
			});
		}

		/**
   * 
   * @param {*} type 
   * @param {*} codes 
   * @param {*} from 
   * @param {*} to 
   * @param {*} depth 
   */
		function getCodeEntriesPerFiscalYear(type, codes, from, to) {
			var depth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

			var params;

			/* Query parameters */
			params = {
				'select': '*,entries:' + type.name + '(' + type.columns + ')',
				'year': ['gte.' + moment(from).format('YYYY'), 'lte.' + moment(to).format('YYYY')],
				'order': 'year.asc'
			};

			params[type.name + '.depth'] = 'lte.' + depth;
			params[type.name + '.order'] = 'code';

			return $http.get(appConfig.apiUrl + '/fiscal_year', { params: params }).then(function (response) {
				var fiscalYears = response.data,
				    codesList = flattenCodesTree(codes);

				codesList.forEach(function (code) {
					code.values = [];
				});

				fiscalYears.forEach(function (fiscalYear) {
					var codesIndexed = _.keyBy(fiscalYear.entries, 'code'),
					    year = moment(fiscalYear.year, 'YYYY').startOf('year');

					codesList.forEach(function (code) {
						var value = _.get(codesIndexed, code.code, {}),
						    extra = { year: year.clone().toDate() };

						code.values.push(Object.assign(value, extra));
					});
				});

				return codes;
			});
		}

		/**
   * 
   */
		function getLatestYearTotals() {

			var params = {
				'select': '*,revenue(*),expenses(*)',
				'revenue.depth': 'lte.1',
				'expenses.depth': 'eq.0',
				'order': 'year.desc',
				'limit': '1'
			};

			return $http.get(appConfig.apiUrl + '/fiscal_year', { params: params }).then(function (r) {
				var entry = r.data[0];

				entry.remainder = _.find(entry.revenue, { depth: 1, code: '5.' });
				entry.revenue = _.find(entry.revenue, { depth: 0 });
				entry.expenses = entry.expenses[0];

				return entry;
			});
		}

		// /**
		//  * 
		//  * @param {*} type 
		//  * @param {*} year 
		//  * @param {*} depth 
		//  * @param {*} hierarchical 
		//  */
		// function getDataByFiscalYear(type, year, depth, hierarchical) {
		// 	var params = {
		// 		select: 'id,year',
		// 		year  : `eq.${year}`,
		// 		limit : 1
		// 	};

		// 	return $http
		// 		.get(`${appConfig.apiUrl}/fiscal_year`, { params: params })
		// 		.then(function(response) {
		// 			var fiscalYearId = (response.data.length === 1) ? response.data[0].id : -1;
		// 			return getDataByFiscalYearId(type, fiscalYearId, depth, hierarchical);
		// 		})
		// 		.then(function(data) {
		// 			return data;
		// 		});
		// }

		// /**
		//  * 
		//  * @param {*} type 
		//  * @param {*} id 
		//  * @param {*} depth 
		//  * @param {*} hierachical 
		//  */
		// function getDataByFiscalYearId(type, id, depth, hierachical) {
		// 	var params = {
		// 		select        : type.columns,
		// 		fiscal_year_id: `eq.${id}`,
		// 		depth         : `lte.${depth || 99}`,
		// 	};

		// 	return $http
		// 		.get(`${appConfig.apiUrl}/${type.name}`, { params: params })
		// 		.then(function(response) {
		// 			/* Return hierarchical or flat data */
		// 			return hierachical ? treeifyCodesList(response.data) : response.data;
		// 		});
		// }


		/**
   * 
   * @param {*} type 
   */
		function getYearRange(type) {
			var extraParams = {
				revenue: { revenue_updated_at: 'not.is.null' },
				expenses: { expenses_updated_at: 'not.is.null' }
			};

			return baseService.getColumnRange('fiscal_year', 'year', extraParams[type] || {}).then(function (response) {
				var years = {
					min: moment(response.min.year).startOf('year'),
					max: moment(response.max.year).endOf('year')
				};
				return years;
			});
		}

		/**
   * 
   * @param {*} code 
   * @param {*} codesList 
   */
		function treeifyCodesList(codesList) {
			var currentCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var codeLabel = '',
			    depth = 0,
			    childrenCodes = [];

			if (currentCode) {
				codeLabel = currentCode.code.substr(0, currentCode.depth);
				depth = currentCode.depth + 1;
			}

			childrenCodes = _(codesList).filter(function (o) {
				return o.depth == depth && o.code.startsWith(codeLabel);
			}).forEach(function (childCode) {
				childCode.parent = currentCode;
				childCode.children = treeifyCodesList(codesList, childCode);
			});

			return childrenCodes;
		}

		/**
   * 
   * @param {*} codesTree 
   */
		function flattenCodesTree(codesTree) {
			return _(codesTree).flatMapDeep(function (code) {
				return [code, flattenCodesTree(code.children)];
			}).value();
		}
	}
})();